module.exports = __webpack_public_path__ + "static/media/roots.28c0efc3.svg";